/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefOrganizationData } from '../../models/api-def-organization-data';

export interface OrganizationsRemoveUser$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * The ID of the user to remove
 */
  userId: string;
}

export function organizationsRemoveUser(http: HttpClient, rootUrl: string, params: OrganizationsRemoveUser$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsRemoveUser.PATH, 'delete');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'organization'?: ApiDefOrganizationData;
      }>;
    })
  );
}

organizationsRemoveUser.PATH = '/organizations/{organizationId}/users/{userId}';
